import localStorageAccessor from '../../helpers/localStorageAccessor/localStorageAccessor'
import localize from './localize'

const dismissLanguages = (): void => {
  localStorageAccessor.dismissedLanguages = localize.getLanguages().map(language => language.code)
}

export default dismissLanguages
